import { render } from "./App.vue?vue&type=template&id=d5ae8870"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d5ae8870&lang=scss"

import exportComponent from "D:\\Desktop\\soccerbettinganalysis\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__